import {Component, Inject, inject} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import { Auth } from 'aws-amplify';
import { OnboardingService } from '../onboarding.service';
import { AuthService } from 'src/app/services/auth.service';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import {AWSLambda} from "../../../AWSLambda.service";
import {TUI_COUNTRIES_MASKS} from "@taiga-ui/kit/tokens";

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
})
export class ForgotComponent {
  username!: string;
  _snackBar = inject(MatSnackBar);
  router = inject(Router);
  onboardingService = inject(OnboardingService);
  authService = inject(AuthService);

  countries: TuiCountryIsoCode[] = [];
  countryIsoCode = TuiCountryIsoCode.ES;

  constructor(
    private lambda: AWSLambda,
    private route: ActivatedRoute,
    @Inject(TUI_COUNTRIES_MASKS) private readonly countriesMasks: Record<TuiCountryIsoCode, string>
  ) { }

  async ngOnInit() {
    try {
      await this.loadCountries();
    } catch (error) {
      this.authService.logout();
    }
  }

  async loadCountries() {
    try {
      const res = await this.lambda.getLambdaFunction('lambda', '/get/contries', {
        queryStringParameters: { method: 'allowedToLogin' }
      });

      if (res.ok) {
        const isoList: string[] = res.countries || [];
        // Filtra los países válidos
        this.countries = isoList
          .map(code => code.toUpperCase())
          .filter(code => Object.values(TuiCountryIsoCode).includes(code as TuiCountryIsoCode))
          .map(code => code as TuiCountryIsoCode);

      } else {
        console.error('Error en la respuesta:', res.mensaje);
      }

    } catch (error) {
      console.error('Error al obtener países:', error);
    }
  }

  async resetPassWord() {
    if (this.username) {
      this.onboardingService.setUsername(this.username);
      return await this.authService
        .resetPassword(this.username)
        .then((e) => {
          this._snackBar.open('Code sended to your Phonenumber', 'Close', {
            duration: 5000,
          });
          this.router.navigate(['/onboarding/new-password'], {
            replaceUrl: true,
          });
        })
        .catch((error) => {
          this._snackBar.open(error.message, 'Close', {
            duration: 5000,
          });
        });
    }
  }

}
